import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { POPUP_DATA, BRAND } from '../../data/mock';
import { MessageCircle, Phone, Mail, PawPrint, ArrowRight } from 'lucide-react';

export const ContactModal = ({ isOpen, onClose }) => {
  const contactOptions = [
    {
      text: "Request a Custom Quote",
      icon: MessageCircle,
      href: BRAND.quoteUrl,
      primary: true,
      external: true
    },
    {
      text: "Call a Local Advisor",
      icon: Phone,
      href: `tel:${BRAND.phone}`,
      primary: false,
      external: false
    },
    {
      text: "Email Us",
      icon: Mail,
      href: `mailto:${BRAND.email}`,
      primary: false,
      external: false
    }
  ];

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg p-0 overflow-hidden border-0 shadow-2xl">
        {/* Header with gradient */}
        <div className="relative bg-gradient-to-br from-teal-600 to-cyan-700 p-8 text-white">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="relative">
            <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-6">
              <PawPrint className="w-8 h-8 text-white" />
            </div>
            <DialogHeader className="text-left space-y-3">
              <DialogTitle className="text-2xl md:text-3xl font-bold text-white">
                {POPUP_DATA.headline}
              </DialogTitle>
              <DialogDescription className="text-white/85 text-base leading-relaxed">
                {POPUP_DATA.copy}
              </DialogDescription>
            </DialogHeader>
          </div>
        </div>

        {/* CTA Options */}
        <div className="p-6 space-y-3">
          {contactOptions.map((option, index) => {
            const IconComponent = option.icon;
            return (
              <Button
                key={index}
                asChild
                variant={option.primary ? 'default' : 'outline'}
                size="lg"
                className={`w-full justify-start text-left h-auto py-4 ${
                  option.primary
                    ? 'text-white shadow-lg shadow-orange-500/25'
                    : 'border-2 hover:bg-teal-50 hover:border-teal-300 hover:text-teal-700'
                }`}
                style={option.primary ? { background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' } : {}}
              >
                <a 
                  href={option.href} 
                  target={option.external ? "_blank" : undefined} 
                  rel={option.external ? "noopener noreferrer" : undefined}
                >
                  <IconComponent className={`w-5 h-5 mr-3 ${option.primary ? 'text-white' : 'text-teal-600'}`} />
                  <span className="flex-1">{option.text}</span>
                  <ArrowRight className="w-4 h-4 ml-2" />
                </a>
              </Button>
            );
          })}
        </div>

        {/* Footer note */}
        <div className="px-6 pb-6">
          <p className="text-sm text-slate-500 text-center">
            No obligation • Free consultation • Licensed in FL, NC & VA
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
